<template>
  <div class="zujian">
      <el-dialog a title="关联车辆" :visible.sync="guanlianMark"  :close-on-click-modal="false" width="900px" @close="closeDialog" center>
      <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="车牌号:" prop="vhcNo">
            <el-input  placeholder="" v-model.trim="SJsearchFrom.vhcNo"></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="SJsearchFn">查询</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="resetForm()">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
        <div>
          <el-table :data="SJList" ref="table"  bordersize="mini"
             class="table" height="380px" style="width: 100%"   center  border   >
            <el-table-column  type="index" width="55" label="序号"></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text"  @click="guanlianfn(scope.row)" size="mini">关联</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
              <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
              <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
              <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
              <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
          </el-table>
        </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="guanlianMark=false">关闭</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { getCVehicleInfo, fleetAddVehicle } from '@/api/vgs-driver2.0'
export default {
  name: 'uploadImg',
  data () {
    return {
      guanlianMark: false,
      tenantCode: '',
      SJsearchFrom: {
        pageNo: 1,
        pageSize: 1000
      },
      SJList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.guanlianMark = true
    this.tenantCode = localStorage.getItem('tenantCode')
  },
  methods: {
    guanlianfn (row) {
      this.$confirm('是否关联车辆' + row.vhcNo + '?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        fleetAddVehicle({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '关联成功',
            type: 'success'
          })
          this.$parent.searchFn()
          this.guanlianMark = false
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      getCVehicleInfo(searchFrom).then(res => {
        if (res.auditStatus == 2) {
          this.SJList = [res]
        } else {
          this.SJList = []
        }

        this.SJtotal = res.total
      })
    },
    resetForm () {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 1000
      }
    },
    closeDialog () {
      this.$emit('update:guanlianFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
